import { render, staticRenderFns } from "./CustomInputComponent.vue?vue&type=template&id=04b13fc6&scoped=true&"
import script from "./CustomInputComponent.vue?vue&type=script&lang=js&"
export * from "./CustomInputComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomInputComponent.vue?vue&type=style&index=0&id=04b13fc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b13fc6",
  null
  
)

export default component.exports